import React from 'react';

import CaretIcon from '@hero/ui-kit/icons/utility/CaretIcon';
import Container from '@hero/ui-kit/layout/Container';
import P from '@hero/ui-kit/typography/P';

import Table from '../../../components/Table';
import * as Style from '../style.module.scss';

type Props = {
    title?: string;
    columns: React.ReactNode[];
    rows?: React.ReactNode[][];
    explanations?: string[];
    loading?: boolean;
    gridTemplateColumns?: string;
    // Starts open; explanations and extra content collapse with the rows.
    collapsible?: boolean;
    // One class per row, same order as `rows` (e.g. a row background).
    rowClassNames?: string[];
    children?: React.ReactNode;
};

const CareTable: React.FC<Props> = ({
    title,
    columns,
    rows,
    explanations = [],
    loading = false,
    gridTemplateColumns = `repeat(${columns.length}, 1fr)`,
    collapsible = false,
    rowClassNames = [],
    children
}) => {
    const table = (
        <Table
            title={collapsible ? undefined : title}
            headerColumns={columns.length ? columns : undefined}
            headerGridTemplateColumns={gridTemplateColumns}
            loading={loading || !rows}
            size="compact"
        >
            {[
                ...(rows?.length
                    ? rows.map((cells, index) => (
                          <Container
                              key={index}
                              gridTemplateColumns={gridTemplateColumns}
                              className={rowClassNames[index]}
                          >
                              {cells.map((cell, cellIndex) => (
                                  <div key={cellIndex}>{cell}</div>
                              ))}
                          </Container>
                      ))
                    : ['—']),
                ...explanations.map((explanation) => (
                    <P key={explanation} size="small" noDefaultMargin>
                        {explanation}
                    </P>
                )),
                ...(children ? [<div key="details">{children}</div>] : [])
            ]}
        </Table>
    );

    return collapsible && title ? (
        <details className={Style.accordion} open>
            <summary className={Style.accordionSummary}>
                <strong>{title}</strong>
                <span className={Style.accordionCaret} aria-hidden="true">
                    <CaretIcon direction="down" size="utility" />
                </span>
            </summary>
            {table}
        </details>
    ) : (
        table
    );
};

export default CareTable;
